import React, { useState, useEffect, useRef } from "react";
import "./Featured.css";
import HeaderTitle from "../HederTitle/HeaderTitle";
import axios from "axios";
import { backend_url } from "../../App";

const Featured = () => {
  const [featuredItems, setFeaturedItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const featuredContainerRef = useRef(null);
  const itemRefs = useRef([]);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);
  const autoplayRef = useRef(null);

  useEffect(() => {
    const fetchFeaturedIn = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/featured-in`);
        setFeaturedItems(response.data);
      } catch (error) {
        console.error("Error fetching featured items:", error);
      }
    };

    fetchFeaturedIn();
  }, []);


  useEffect(() => {
    if (window.innerWidth >= 768) return; // Only autoplay on mobile

    autoplayRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % featuredItems.length;
        scrollToItem(nextIndex);
        return nextIndex;
      });
    }, 3000); // change slide every 3 seconds

    return () => clearInterval(autoplayRef.current);
  }, [featuredItems]);




  useEffect(() => {
    const container = featuredContainerRef.current;
    if (!container || featuredItems.length === 0) return;

    const handleScroll = () => {
      const containerWidth = container.offsetWidth;
      const scrollPosition = container.scrollLeft + containerWidth / 2;

      let activeItemIndex = 0;
      itemRefs.current.forEach((item, index) => {
        if (item) {
          const itemLeft = item.offsetLeft;
          const itemWidth = item.offsetWidth;
          if (scrollPosition > itemLeft && scrollPosition < itemLeft + itemWidth) {
            activeItemIndex = index;
          }
        }
      });

      setActiveIndex(activeItemIndex);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [featuredItems]);

  const scrollToItem = (index) => {
    const container = featuredContainerRef.current;
    const item = itemRefs.current[index];

    if (container && item) {
      const containerWidth = container.offsetWidth;
      const itemWidth = item.offsetWidth;
      const scrollPosition = item.offsetLeft - (containerWidth - itemWidth) / 2;

      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  // Mouse events for drag scrolling
  const startDrag = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - featuredContainerRef.current.offsetLeft);
    setScrollLeft(featuredContainerRef.current.scrollLeft);
    clearInterval(autoplayRef.current); // Stop autoplay on drag
  };

  const endDrag = () => {
    setIsDragging(false);
    if (window.innerWidth < 768) {
      // Resume autoplay on mobile
      autoplayRef.current = setInterval(() => {
        setActiveIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % featuredItems.length;
          scrollToItem(nextIndex);
          return nextIndex;
        });
      }, 3000);
    }
  };


  const duringDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - featuredContainerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust multiplier for faster/slower drag
    featuredContainerRef.current.scrollLeft = scrollLeft - walk;
  };


  return (
    <>
      <HeaderTitle Header="Featured In" />
      <div className="featured-container">
        <div
          className="featured-items"
          ref={featuredContainerRef}
          onMouseDown={startDrag}
          onMouseMove={duringDrag}
          onMouseUp={endDrag}
          onMouseLeave={endDrag}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          {featuredItems.map((item, index) => (
            <div
              className="featured-item"
              key={index}
              ref={el => itemRefs.current[index] = el}
            >
              <img loading="lazy" crossOrigin="anonymous"  src={`${item.image}`} alt={item.alt} className="featured-image" />
              <div className="logo-container">
                <img loading="lazy" crossOrigin="anonymous"  src={`${item.icon_image}`} alt={item.alt} className="logo-image" />
              </div>
            </div>
          ))}
        </div>
        <div className="carousel-indicators">
          {featuredItems.map((_, index) => (
            <span
              key={index}
              className={`carousel-dot ${index === activeIndex ? "active" : ""}`}
              onClick={() => scrollToItem(index)}
            >
              {index === activeIndex && <div className="carousel-bar"></div>}
            </span>
          ))}
        </div>

      </div>
    </>
  );
};

export default Featured;